import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import Resourcedetails from "./Resourcedetails";
import { useTranslation } from "react-i18next";

const FavoriteItem = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "favoriteItem" });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const RAMURL = "http://kidshelpphone.develop";
  const [reourcedetails, setReourcedetails] = useState({});
  const [address, setAddress] = useState("");
  const [mapaddress, setMapaddress] = useState("");
  const [ramhours, setRamhours] = useState("");
  const [maplink, setMaplink] = useState(false);
  const [showmap, setShowmap] = useState(false);
  const [isshowotherdetails, setIsshowotherdetails] = useState(false);
  const favoritearray = useSelector((state) => state.favoritearray);
  const dispatch = useDispatch();
  const [accordionCollapsed, setAccordionCollapsed] = useState(true);
  useEffect(async () => {
    getDetails();
  }, []);

  const getDetails = async () => {
    //const resourceDetailsURL = queryParams.get("id").split("_");
    const resourceID = props.etlloadid;
    const response = await axios.get(
      process.env.REACT_APP_REACT_APP_API_END_POINT +
        process.env.REACT_APP_GET_RESOURCES_BY_ID +
        resourceID +
        "?code=" +
        process.env.REACT_APP_API_KEY
    );
    //console.log(response.data);
    setReourcedetails(response.data);
    if (response.data.Latitude && response.data.Longitude) setShowmap(true);
    else setShowmap(false);
    //return response.data;

    const RAM = response.data;

    if (RAM.Map != "Shelter") {
      if (RAM.IsHelpline != true) {
        const address = [];
        if (RAM.PhysicalAddress) {
          address.push(RAM.PhysicalAddress);
        }
        if (RAM.City) {
          address.push(RAM.City);
        }
        if (RAM.PhysicalCountry) {
          address.push(RAM.PhysicalCountry);
        }
        if (RAM.PhysicalPostalCode) {
          address.push(RAM.PhysicalPostalCode);
        }

        setAddress(address.join(", "));
        setMapaddress(
          "https://www.google.com/maps?daddr=" +
            RAM.PhysicalAddress +
            ", " +
            RAM.City +
            ", " +
            RAM.PhysicalCountry +
            ", " +
            RAM.PhysicalPostalCode
        );
        setMaplink(true);
      }
    }

    let hoursSection = "";
    if (RAM.WorkHours || RAM.HoursOfOperation) {
      hoursSection = hoursSection + '<div class="timings"><h3>'+ t("open_hours") +'</h3>';
      if (RAM.WorkHours != "") var WorkHours = RAM.WorkHours.split(";");
      if (Array.isArray(WorkHours)) {
        for (var i = 0; i < WorkHours.length; i++) {
          if (WorkHours[i] != "") {
            hoursSection =
              hoursSection +
              "<p><span>" +
              WorkHours[i].substr(0, 4).trim() +
              "</span>" +
              WorkHours[i].substr(4) +
              "</p>";
          }
        }
      }

      hoursSection = hoursSection + "<p>" + RAM.HoursOfOperation + "</p></div>";
    }

    setRamhours(hoursSection);

    if (
      RAM.FeeStructureSource ||
      RAM.CustomEligibilitybyAge ||
      RAM.Eligibility ||
      RAM.DisabilitiesAccess ||
      RAM.LanguagesOfferedList ||
      RAM.NormalWaitTime
    ) {
      setIsshowotherdetails(true);
    }
  };

  const removeFavouriteItem = () => {
    //favoritearray.push(event.target.dataset.id);
    const updatedfavoritearray = favoritearray.filter((index) => {
      if (index != props.etlloadid) return index;
    });
    dispatch(ramactions.addfavorite(updatedfavoritearray));
    dispatch(ramactions.faviruteRemoved(true));
    setTimeout(() => {
      dispatch(ramactions.faviruteRemoved(false));
    }, 4000);
  };
  /* useEffect(()=>{
    let accordion = document.querySelector('.accordion-wrapper');
    let accordionHeader = accordion.querySelectorAll('.accordion-header');
    for(let i=0;i<accordionHeader.length; i++){
      accordionHeader[i].querySelector('button').addEventListener('click', function(){
        if(this.parentElement.parentElement.parentElement.classList.contains('open')){
          this.parentElement.parentElement.parentElement.classList.remove('open');
          this.setAttribute('aria-expanded', 'false');
        }else{
          this.parentElement.parentElement.parentElement.classList.remove('open');
          this.setAttribute('aria-expanded', 'true');
        }
      })
    }
  },[]) */

  const collapseHandler = (event) => {
    if (event.target.nodeName === "BUTTON") {
      if (
        event.target.parentElement.parentElement.parentElement.classList.contains(
          "open"
        )
      ) {
        setAccordionCollapsed(true);
      } else {
        setAccordionCollapsed(false);
      }
    } else if (event.target.parentElement.nodeName === "BUTTON") {
      if (
        event.target.parentElement.parentElement.parentElement.parentElement.classList.contains(
          "open"
        )
      ) {
        setAccordionCollapsed(true);
      } else {
        setAccordionCollapsed(false);
      }
    } else if (event.target.parentElement.parentElement.nodeName === "BUTTON") {
      if (
        event.target.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains(
          "open"
        )
      ) {
        setAccordionCollapsed(true);
      } else {
        setAccordionCollapsed(false);
      }
    } else if (
      event.target.parentElement.parentElement.parentElement.nodeName ===
      "BUTTON"
    ) {
      if (
        event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.contains(
          "open"
        )
      ) {
        setAccordionCollapsed(true);
      } else {
        setAccordionCollapsed(false);
      }
    }
  };
  return (
    <div className={`accordion-container ${!accordionCollapsed ? "open" : ""}`}>
      <div className="accordion-header">
        <h3>
          <button
            type="button"
            data-toggle="collapse"
            aria-expanded={!accordionCollapsed ? "true" : "false"}
            onClick={collapseHandler}
          >
            <span role="text">
              <span class="heading">
                <span class="header-four">
                  {reourcedetails.Name}
                  {reourcedetails.id}
                </span>
                <span class="bts bt-star" aria-hidden="true"></span>
              </span>
              <span class="address">{address}</span>

              {reourcedetails.Phone && <p>{t("phone")}: {reourcedetails.Phone}</p>}

              {reourcedetails.WebsiteAddress && (
                <p class="website">
                  <span>{t("website")}: </span> {reourcedetails.WebsiteAddress}
                </p>
              )}
            </span>
          </button>
        </h3>
      </div>
      <div
        className="accordion-body"
        aria-hidden={accordionCollapsed && "true"}
        tabindex={accordionCollapsed ? "-1" : "0"}
      >
        <div className="inner-content">
          {reourcedetails.AgencyDescription && (
            <Fragment>
              <h3>{t("about")}</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: reourcedetails.AgencyDescription,
                }}
              ></p>
            </Fragment>
          )}
          <Fragment dangerouslySetInnerHTML={{ __html: ramhours }}></Fragment>
          <h3>{t("details")}</h3>
          <div className="accordion-details">
            {reourcedetails.FeeStructureSource && (
              <p>
                <span>{t("cost")} : </span>
                {reourcedetails.FeeStructureSource}
              </p>
            )}
            {reourcedetails.CustomEligibilitybyAge && (
              <p>
                <span>{t("age_limit")} : </span>
                {reourcedetails.CustomEligibilitybyAge.trim()}
              </p>
            )}
            {reourcedetails.Eligibility && (
              <p>
                <span>{t("eligibility")} : </span>
                {reourcedetails.Eligibility.trim()}
              </p>
            )}
            {reourcedetails.DisabilitiesAccess && (
              <p>
                <span>{t("accessibility")} : </span>
                {reourcedetails.DisabilitiesAccess.trim()}
              </p>
            )}
            {reourcedetails.LanguagesOfferedList && (
              <p>
                <span>{t("languages_offered")} : </span>
                {reourcedetails.LanguagesOfferedList.trim()}
              </p>
            )}
            {reourcedetails.NormalWaitTime && (
              <p>
                <span>{t("wait_times")}:</span>
                {reourcedetails.NormalWaitTime.trim()}
              </p>
            )}
          </div>
          {reourcedetails.ApplicationProcess && (
            <Fragment>
              <h3 class="header-four">{t("application_process")}</h3>
              <p>{reourcedetails.ApplicationProcess}</p>
            </Fragment>
          )}
          {reourcedetails.DocumentsRequired && (
            <Fragment>
              <h3 class="header-four">{t("documents_required")}</h3>
              <p>{reourcedetails.DocumentsRequired}</p>
            </Fragment>
          )}
          {reourcedetails.Coverage && (
            <Fragment>
              <h3 class="header-four">{t("coverage_area")}</h3>
              <p>{reourcedetails.Coverage}</p>
            </Fragment>
          )}
          <Link
            onClick={removeFavouriteItem}
            className="save-fav add-to-favourites-details"
            role="button"
            aria-hidden={accordionCollapsed && "true"}
            tabindex={accordionCollapsed && "-1"}
          >
            <span class="bts bt-star fav" aria-hidden="true"></span>{t("remove_from_favourites")}
          </Link>
        </div>
      </div>
      {/* <h2>{reourcedetails.Name}</h2> */}
      {/* <div>{address}</div> */}
      {/* {reourcedetails.Phone && <div>{reourcedetails.Phone}</div>} */}
      {/* {reourcedetails.WebsiteAddress && (
        <p class="website">
          <span>Website: </span> {reourcedetails.WebsiteAddress}
        </p>
      )} */}
      {/* {reourcedetails.AgencyDescription && (
        <div
          dangerouslySetInnerHTML={{ __html: reourcedetails.AgencyDescription }}
        ></div>
      )}
      <div dangerouslySetInnerHTML={{ __html: ramhours }}></div>
      <h3>Details</h3>
      <div class="accordion-details">
        {reourcedetails.FeeStructureSource && (
          <p>
            <span class="font-weight-bold">Cost:</span>
            {reourcedetails.FeeStructureSource}
          </p>
        )}
        {reourcedetails.CustomEligibilitybyAge && (
          <p>
            <span class="font-weight-bold">Age limit:</span>
            {reourcedetails.CustomEligibilitybyAge.trim()}
          </p>
        )}
        {reourcedetails.Eligibility && (
          <p>
            <span class="font-weight-bold">Eligibility:</span>
            {reourcedetails.Eligibility.trim()}
          </p>
        )}
        {reourcedetails.DisabilitiesAccess && (
          <p>
            <span class="font-weight-bold">Accessibility:</span>
            {reourcedetails.DisabilitiesAccess.trim()}
          </p>
        )}
        {reourcedetails.LanguagesOfferedList && (
          <p>
            <span class="font-weight-bold">Languages offered:</span>
            {reourcedetails.LanguagesOfferedList.trim()}
          </p>
        )}
        {reourcedetails.NormalWaitTime && (
          <p>
            <span class="font-weight-bold">Wait times:</span>
            {reourcedetails.NormalWaitTime.trim()}
          </p>
        )}
        {reourcedetails.ApplicationProcess && (
          <Fragment>
            <h3 class="header-four">Application process</h3>
            <p>{reourcedetails.ApplicationProcess}</p>
          </Fragment>
        )}
        {reourcedetails.DocumentsRequired && (
          <Fragment>
            <h3 class="header-four">Documents required</h3>
            <p>{reourcedetails.DocumentsRequired}</p>
          </Fragment>
        )}
        {reourcedetails.Coverage && (
          <Fragment>
            <h3 class="header-four">Coverage area</h3>
            <p>{reourcedetails.Coverage}</p>
          </Fragment>
        )}
        <button onClick={removeFavouriteItem}>Remove From Favourites</button>
      </div> */}
    </div>
  );
};

export default FavoriteItem;
